import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

const SCHEMA_ORG_MAP: Record<string, string> = {};

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const id = `schema-${type}`;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.setAttribute('type', 'application/ld+json');
      document.head.appendChild(el);
    }

    const schema = {
      '@context': 'https://schema.org',
      '@type': type,
      ...data,
    };

    el.textContent = JSON.stringify(schema, null, 2);

    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, [type, data]);

  return null;
}